/**
 * Helper functions to detect if MetaMask is installed
 */

export const isMetaMaskInstalled = () => {
  // Check if the ethereum provider exists and has isMetaMask property
  try {
    return typeof window.ethereum !== 'undefined' && !!window.ethereum.isMetaMask;
  } catch (error) {
    console.log('Error checking MetaMask installation:', error);
    return false;
  }
};

export const detectProvider = () => {
  // Detect the provider being used
  try {
    if (window.ethereum) {
      if (window.ethereum.isMetaMask) {
        return 'MetaMask';
      } else if (window.ethereum.isCoinbaseWallet) {
        return 'Coinbase Wallet';
      } else {
        return 'Unknown Web3 Provider';
      }
    }
  } catch (error) {
    console.log('Error detecting provider:', error);
  }
  return 'No Web3 Provider';
};

export const getProviderInfo = () => {
  try {
    if (!window.ethereum) {
      return {
        installed: false,
        name: 'None',
        message: 'No Web3 wallet detected. Please install MetaMask to use blockchain features.'
      };
    }
    
    const provider = detectProvider();
    
    return {
      installed: true,
      name: provider,
      message: `Connected to ${provider}`
    };
  } catch (error) {
    console.log('Error getting provider info:', error);
    return {
      installed: false,
      name: 'None',
      message: 'Error detecting Web3 wallet. Please install MetaMask to use blockchain features.'
    };
  }
};